import axiosPost from "./axiosPost";

export const MerchantBOBPDel= async (credentials, data) => {
    const body = {
        service: "MerchantBOBPDel",
        params: {
            merchantBeneficiarioId: data.merchantBeneficiarioId,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}